import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { SettingsService } from '../settings/settings.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private languageSubject = new Subject<string>();

  constructor(
    private settingsService: SettingsService,
    private translate: TranslateService
  ) {}

  async init(): Promise<void> {
    const storedLanguage = this.settingsService.getLocaleId();
    const defaultLanguage = 'de';
    const finalLang = storedLanguage || defaultLanguage;
    this.languageSubject.next(finalLang);
    this.settingsService.setLocaleId(finalLang);
    this.translate.setDefaultLang(finalLang);
    return await this.translate.use(finalLang).toPromise();
  }

  setLanguage(language: string) {
    this.languageSubject.next(language);
    this.settingsService.setLocaleId(language);
    this.translate.use(language);
  }

  getLanguage(): Observable<string> {
    return this.languageSubject.asObservable();
  }
}
